export const blockIconsTextformattingEditNoteNew = (
	<span className='material-symbols-outlined'>edit_note</span>
);
